import type { NeedStatus } from "@/lib/order-check";

/** Классы Tailwind по статусу позиции (складская семантика: emerald/amber/red).
 *  Общий примитив скан-экранов (order-check / transfer-check / returns). */
export const STATUS_ROW: Record<NeedStatus, string> = {
  idle: "border-slate-200 bg-white",
  partial: "border-amber-200 bg-amber-50",
  done: "border-emerald-200 bg-emerald-50",
  over: "border-red-200 bg-red-50",
};

export const STATUS_TEXT: Record<NeedStatus, string> = {
  idle: "text-slate-700",
  partial: "text-amber-700",
  done: "text-emerald-700",
  over: "text-red-700",
};

/** Форматирование количества: целое без дробной части, иначе компактно. */
export function fmtQty(q: number): string {
  return Number.isInteger(q) ? String(q) : String(Number(q.toFixed(3)));
}
